import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * <RequireRole roles={['member','admin']}>...</RequireRole>
 * Redirects users to the home appropriate for their role.
 * - Unauthenticated → /login
 * - Wrong role → their own home (supporter → /app/support-home, otherwise → /app)
 */
export default function RequireRole({ roles = [], children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const role = user.is_admin ? 'admin' : (user.role || 'member');
  const allowed = roles.includes(role) || roles.includes('*');
  if (!allowed) {
    const dest = role === 'supporter' ? '/app/support-home' : '/app';
    return <Navigate to={dest} replace />;
  }
  return children;
}
